import { FaHome, FaUser, FaPaperPlane, FaBuilding, FaBed, FaUtensils, FaUserTie, FaCreditCard, FaChartBar, FaLock, FaSignOutAlt } from 'react-icons/fa';

const menuItems = [
  { 
    key: 'dashboard', 
    label: 'Dashboard', 
    icon: <FaHome />, 
    enabled: true, 
    path: '/dashboard',
    access_roles: ['RT_Admin', 'RT_Staff', 'RT_PayingGuest', 'RT_NoAccess'] // All roles can access dashboard
  },
  { 
    key: 'paying-guest', 
    label: 'Paying Guest', 
    icon: <FaUser />, 
    enabled: true, 
    path: '/paying-guest',
    access_roles: ['RT_Admin'] // Staff and above
  },
  { 
    key: 'building', 
    label: 'Buildings', 
    icon: <FaBuilding />, 
    enabled: true, 
    path: '/building',
    access_roles: ['RT_Admin'] // Manager and above
  },
  { 
    key: 'bedmanagement', 
    label: 'Bed Management', 
    icon: <FaBed />, 
    enabled: true, 
    path: '/bedallocation',
    access_roles: ['RT_Admin'] // Staff and above
  },
  { 
    key: 'payments', 
    label: 'Payments', 
    icon: <FaCreditCard />, 
    enabled: true, 
    path: '/payments',
    access_roles: ['RT_Admin'] // Manager and above
  },
  { 
    key: 'food', 
    label: 'Food', 
    icon: <FaUtensils />, 
    enabled: false, 
    path: '/food',
    access_roles: [] // Staff and above
  },
  { 
    key: 'staffs', 
    label: 'Staffs', 
    icon: <FaUserTie />, 
    enabled: true, 
    path: '/staffs',
    access_roles: ['RT_Admin'] // Admin only
  },
  { 
    key: 'complaints', 
    label: 'Complaints', 
    icon: <FaPaperPlane />, 
    enabled: true, 
    path: '/complaints',
    access_roles: ['RT_Admin', 'RT_Staff'] // Admin and Staff can manage complaints
  },
  { 
    key: 'reports', 
    label: 'Reports', 
    icon: <FaChartBar />, 
    enabled: true, 
    path: '/reports',
    access_roles: ['RT_Admin'] // Manager and above
  },
  { 
    key: 'settings', 
    label: 'Settings', 
    icon: <FaLock />, 
    enabled: true, 
    path: '/settings',
    access_roles: ['RT_Admin', 'RT_Staff', 'RT_PayingGuest', 'RT_NoAccess'] // All roles can access settings
  },
  { 
    key: 'logout', 
    label: 'Logout', 
    icon: <FaSignOutAlt />, 
    enabled: true, 
    path: '/logout',
    access_roles: ['RT_Admin', 'RT_Staff', 'RT_PayingGuest', 'RT_NoAccess'] // Everyone can logout
  },
];

export default menuItems;